"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationBackup = void 0;
const react_1 = __importStar(require("react"));
const components_1 = require("@veeam/components");
const core_1 = require("@veeam/core");
const Warning_svg_1 = __importDefault(require("@veeam/uikit-assets/src/icons/status/Warning/Warning.svg"));
const constants_1 = require("../../constants");
const core_2 = require("../../core");
const helpers_1 = require("../../helpers");
const dialogs_1 = require("../dialogs");
const ConfigurationBackupInteractor_1 = require("./ConfigurationBackupInteractor");
const components_2 = require("./components");
require("./types");
const ConfigurationBackup = ({ mode, model, repositoriesDataGridModelLoader, availableRestorePointsDataGridModelLoader, currentSettingsLoadableModel, saveLoadableModel, exportLoadableModel, removeRestorePointLoadableModel, repositoriesLoadableModel, createManualBackupLoadableModel, onCatchError, onRestore, onGoToSessionLogsPage, onSaveDone, onBackupDone, onExportDone, }) => {
    const { t } = core_2.useFeatureContext();
    const [isLoading, loadingState] = react_1.useState(false);
    const [isSaving, savingState] = react_1.useState(false);
    const [isSaved, savedState] = react_1.useState(false);
    const [repositoriesDialog, repositoriesDialogActions] = components_1.useModal({
        render: ({ deactivate, data }) => {
            if (!data) {
                return null;
            }
            return (react_1.default.createElement(dialogs_1.RepositoriesDialog, { dataGridLoader: repositoriesDataGridModelLoader, repositoryId: data.repositoryId, onDeactivate: deactivate, onDone: data.onDone, onCancel: data.onCancel, onClose: data.onClose, displayedColumns: {
                    encryption: false,
                } }));
        },
    });
    const [availableRestorePointsDialog, availableRestorePointsDialogActions] = components_1.useModal({
        render: ({ deactivate, data }) => {
            if (!data) {
                return null;
            }
            return (react_1.default.createElement(dialogs_1.AvailableRestorePointsDialog, { dataGridLoader: availableRestorePointsDataGridModelLoader, onRestore: onRestore, onRemove: data.onRemove, onExport: data.onExport, onDeactivate: deactivate, onCancel: data.onCancel, onClose: data.onClose }));
        },
    });
    const [daysDialog, daysDialogActions] = components_1.useModal({
        render: ({ deactivate, data }) => {
            if (!data) {
                return null;
            }
            return (react_1.default.createElement(dialogs_1.DaysDialog, { selectedDays: data.selectedDays, mode: data.mode, onDeactivate: deactivate, onDone: data.onDone, onCancel: data.onCancel, onClose: data.onClose }));
        },
    });
    const [exportLatestBackupDialog, exportLatestBackupActions] = components_1.useModal({
        render: ({ deactivate, data }) => {
            if (!data) {
                return null;
            }
            return (react_1.default.createElement(dialogs_1.ExportLatestBackupDialog, { isLoading: isLoading, onDeactivate: deactivate, onDone: data.onDone, onCancel: data.onCancel, onClose: data.onClose }));
        },
    });
    const [goToSessionLogsDialog, onGoToSessionLogsDialogShow] = helpers_1.useMessage({
        iconSrc: Warning_svg_1.default,
        header: t('configurationBackup|goToSessionLogsDialog|header'),
        doneLabel: t('configurationBackup|goToSessionLogsDialog|doneActionLabel'),
        cancelLabel: t('configurationBackup|goToSessionLogsDialog|cancelActionLabel'),
        onDone: onGoToSessionLogsPage,
    });
    const [createManualBackupConfigDialog, createManualBackupConfigDialogActions] = components_1.useModal({
        render: ({ deactivate, data }) => {
            if (!data) {
                return null;
            }
            return (react_1.default.createElement(dialogs_1.CreateManualBackupDialog, { initialRepository: data.initialRepository, createManualBackupLoadableModel: createManualBackupLoadableModel, repositoriesLoadableModel: repositoriesLoadableModel, onCatchError: onCatchError, onDeactivate: deactivate, onCancel: data.onCancel, onClose: data.onClose, onDone: data.onDone }));
        },
    });
    const { interactor } = core_1.useInteractor(() => {
        const config = {
            goToSessionLogsDialogMessage: t('configurationBackup|goToSessionLogsDialog|message'),
        };
        const loaders = {
            currentSettingsLoadableModel,
            exportLoadableModel,
            removeRestorePointLoadableModel,
            saveLoadableModel,
        };
        const presenters = {
            loadingState,
            savingState,
            savedState,
            onRepositoriesDialogActivate: repositoriesDialogActions.activate,
            onAvailableRestorePointsDialogActivate: availableRestorePointsDialogActions.activate,
            onDaysDialogActivate: daysDialogActions.activate,
            onExportLatestBackupActivate: exportLatestBackupActions.activate,
            onCreateManualBackupActivate: createManualBackupConfigDialogActions.activate,
            onGoToSessionLogsDialogShow,
            onCatchError,
        };
        const listeners = {
            onSaveDone,
            onBackupDone,
            onExportDone,
        };
        return new ConfigurationBackupInteractor_1.ConfigurationBackupInteractor(model, loaders, config, presenters, listeners);
    });
    const { isValid, hasChanges } = core_1.useFormMeta(interactor.form);
    const isManagedPlatform = ConfigurationBackupInteractor_1.ConfigurationBackupInteractor.isManagedPlatform(mode);
    const isManagedVBR = ConfigurationBackupInteractor_1.ConfigurationBackupInteractor.isManagedVBR(mode);
    const { value: modelValue } = core_1.useModel(interactor.model);
    const isModified = () => {
        try {
            if (isSaved && hasChanges) {
                savedState(false);
            }
            return hasChanges;
        }
        catch (e) {
            return false;
        }
    };
    const routeConfirm = core_1.useRouteConfirm({
        showConfirm: isModified(),
        render: ({ isActive, cancel, confirm }) => (react_1.default.createElement(components_1.Modal, { isShown: isActive, render: () => (react_1.default.createElement(dialogs_1.ConfirmSaveDialog, { isSaveDisabled: isLoading || isSaving || !isValid, isSaved: isSaved, onSave: interactor.onSave, onConfirm: confirm, onCancel: cancel })) })),
    });
    return (react_1.default.createElement(components_1.Section, null,
        isManagedVBR && (react_1.default.createElement(components_1.Section, null,
            react_1.default.createElement(components_2.CurrentConfiguration, { model: interactor.model }))),
        isManagedPlatform && (react_1.default.createElement(components_1.Section, null,
            react_1.default.createElement(components_1.Section, null,
                react_1.default.createElement(components_2.Restore, { isDisabled: isSaving || isLoading, onRestoreConfiguration: onRestore, onAvailableRestorePoint: interactor.onAvailableRestorePointsDialogShow })),
            react_1.default.createElement(components_1.Section, null,
                react_1.default.createElement(components_2.ManualBackup, { model: interactor.model, status: modelValue.status, isDisabled: isSaving || isLoading, isLoading: isLoading, onBackup: interactor.onBackupDialogShow, onExport: interactor.onExportLatestBackupDialogShow }),
                react_1.default.createElement(components_1.View, { borderTop: components_1.VIEW_BORDER.normal, indentTop: components_1.VIEW_INDENT.m, indentBottom: components_1.VIEW_INDENT.l }),
                react_1.default.createElement(components_2.BackupSchedule, { form: interactor.form, isSaving: isSaving, isSaved: isSaved, isModified: isModified, onDaysDialogShow: () => {
                        interactor.onDaysDialogShow(dialogs_1.DAYS_DIALOG_MODE.selection);
                    }, onRepositoriesDialogShow: interactor.onRepositoriesDialogShow, onSave: () => __awaiter(void 0, void 0, void 0, function* () {
                        yield interactor.onSave();
                    }) })))),
        goToSessionLogsDialog,
        repositoriesDialog,
        availableRestorePointsDialog,
        daysDialog,
        exportLatestBackupDialog,
        createManualBackupConfigDialog,
        routeConfirm,
        isLoading && !isSaving && (react_1.default.createElement(components_1.Overlay, { view: components_1.OVERLAY_VIEW.soft, contentMod: components_1.OVERLAY_CONTENT_MOD.center },
            react_1.default.createElement(components_1.Spinner, { size: constants_1.SPINNER_SIZES.xxl })))));
};
exports.ConfigurationBackup = ConfigurationBackup;
//# sourceMappingURL=ConfigurationBackup.js.map